import { gql } from '@apollo/client'
import {
    AccountFirmFragment,
    FirmFragments,
} from 'api/graphQL/fragments/firm.fragments'
import { FirmProfileInfoFragments } from 'api/graphQL/fragments/firmProfileInfo.fragments'
import { processEnv } from 'components/configuration/environmentVariables'

export const FirmDescriptionQuery = gql`
    query firmDescriptionQuery($firmId: String!) {
        firm(firmId: $firmId) @client {
            id
            description
        }
    }
`

export const FirmLogoQuery = gql`
    query firmLogoQuery($firmId: String!) {
        firm(firmId: $firmId) @client {
            id
            logoUrl
        }
    }
`

export const FirmAddressDetailQuery = gql`
    query firmAddressDetailQuery($firmId: String!) {
        firm(firmId: $firmId) @client {
            id
            address
            contactInfo
            publicPhone
            website
        }
    }
`

export const FirmAccountSettingsQuery = gql`
    query FirmQuery($id: String!) {
        firm(id: $id) {
            id
            name
            subscriptionInfo {
                ...subscriptionInfoFragment
            }
            displayName
            profileInfo {
                ...firmProfileInfoFragment
            }
            status
            supportContactUser {
                ...supportContactUserFragment
            }
            totalUsers
            isSpecTextLibraryVisible
            ${processEnv.REACT_APP_ShowMFACheckbox === '1' ? 'isMFARequiredForLogins isMFARequiredForLoginsEnabledDate' : ''}
        }
    }
    ${FirmFragments.subscriptionInfoFragment}
    ${FirmProfileInfoFragments.firmProfileInfoFragment}
    ${FirmFragments.supportContactUserFragment}
`

export const FirmDesignatedAccountAdminQuery = gql`
    query FirmDesignatedAccountAdmin($id: String!) {
        firm(id: $id) {
            id
            designatedAccountAdminUserId
        }
    }
`

export const FirmSupportContactUserQuery = gql`
    query FirmSupportContactUser($firmId: String!) {
        firm(id: $firmId) {
            id
            designatedAccountAdminUser {
                id
                email
                status
            }
            hideIndustryAnalytics
            name
            subscriptionInfo {
                salesforceId
            }
        }
    }
`

export const FirmUsersQuery = gql`
    query getUsers($firmId: String!) {
        firm(id: $firmId) {
            id
            totalUsers
            users {
                ...firmUsersFragment
            }
            designatedAccountAdminUserId
            subscriptionInfo {
                ...subscriptionInfoFragment
            }
            ${processEnv.REACT_APP_ShowMFACheckbox === '1' ? 'isMFARequiredForLogins' : ''}
        }
    }
    ${FirmFragments.firmUsersFragment}
    ${FirmFragments.subscriptionInfoFragment}
`
export const FirmListingUsersQuery = gql`
    query getUsers($firmId: String!) {
        firm(id: $firmId) {
            totalUsers
            users {
                ...firmUsersFragment
            }
            designatedAccountAdminUser {
                ...firmUsersFragment
            }
        }
    }
    ${FirmFragments.firmUsersFragment}
`

export const FirmListingUsersQueryCountOnly = gql`
    query getUsers($firmId: String!) {
        firm(id: $firmId) {
            totalUsers
            designatedAccountAdminUser {
                ...firmUsersFragment
            }
        }
    }
    ${FirmFragments.firmUsersFragment}
`

export const FirmUserCount = gql`
    query getFirmUserCountInfo($firmId: String!) {
        firm(id: $firmId) {
            id
            totalUsers
            subscriptionInfo {
                ...subscriptionInfoFragment
            }
        }
    }
    ${FirmFragments.subscriptionInfoFragment}
`

export const FirmProfileInfoQuery = gql`
    query firmProfileQuery($firmId: String!) {
        firm(id: $firmId) {
            id
            name
            displayName
            profileInfo {
                ...firmProfileInfoPageFragment
            }
        }
    }
    ${FirmProfileInfoFragments.firmProfileInfoPageFragment}
`
export const FirmNameQuery = gql`
    query firmNameQuery($firmId: String!) {
        firm(id: $firmId) {
            id
            name
            displayName
        }
    }
`
export const FirmIdByDisplayNameQuery = gql`
    query firmNameQuery($firmName: String!) {
        getFirmByDisplayName(displayName: $firmName) {
            firmId
            displayName
            profileInfo {
                website
            }
        }
    }
`

export const FirmAutoSuggestQuery = gql`
    query FirmAutoSuggestQuery($input: FirmAutoSuggestInput!) {
        firmAutoSuggest(input: $input) {
            result
        }
    }
`

export const AllFirmsQuery = gql`
    query allFirmsQuery {
        allFirms {
            id
            name
            accountTypeDisplay
            subscriptionInfo {
                ...subscriptionInfoFragment
            }
            status
            supportContactUser {
                ...supportContactUserFragment
            }
            ${processEnv.REACT_APP_ShowMFACheckbox === '1' ? 'isMFARequiredForLogins' : ''}
            ${processEnv.REACT_APP_ShowProductScraper === '1' ? 'scrapeJobStatus { status startedAt completedAt csvFilename }' : ''}
        }
    }
    ${FirmFragments.subscriptionInfoFragment}
    ${FirmFragments.supportContactUserFragment}
`
export const FirmQuery = gql`
    query firmQuery($id: String!) {
        firm(id: $id) {
            ...accountFirmFragment
        }
    }
    ${AccountFirmFragment}
`
